export default {
  totalCharacters: 100,
  allTimeDuration: [
    { id: 1, name: "1 min" },
    { id: 5, name: "5 min" },
    { id: 10, name: "10 min" },
    { id: 15, name: "15 min" },
    { id: "free", name: "Free Time" },
  ],
  selectedTimeDuration: "free",
  lessons: [
    { name: "f j", key: "" },
    { name: "d k", key: "" },
    { name: "f j d k", key: "" },
    { name: "s l", key: "" },
    { name: "a ;", key: "" },
    { name: "s l a ;", key: "" },
    { name: "g h", key: "" },
    { name: "f j d k s l a ; g h", key: "Middle Row" },
    { name: "r u", key: "" },
    { name: "e i", key: "" },
    { name: "r u e i", key: "" },
    { name: "w o", key: "" },
    { name: "q p", key: "" },
    { name: "w o q p", key: "" },
    { name: "t y", key: "" },
    { name: "r u e i w o q p t y", key: "Top Row" },
    { name: "v m", key: "" },
    { name: "c ,", key: "" },
    { name: "v m c ,", key: "" },
    { name: "x .", key: "" },
    { name: "z /", key: "" },
    { name: "x . z /", key: "" },
    { name: "b n", key: "" },
    { name: "v m c , x . z / b n", key: "Bottom Row" },
  ],
};
